<template>
  <transition name="sg-collapse-transition" v-on="on">
    <slot></slot>
  </transition>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SgCollapseTransition',
  setup() {
    return {
      on: {
        beforeEnter(sg) {
          if (!sg.dataset) sg.dataset = {}

          sg.dataset.oldPaddingTop = sg.style.paddingTop
          sg.dataset.oldPaddingBottom = sg.style.paddingBottom

          sg.style.maxHeight = 0
          sg.style.paddingTop = 0
          sg.style.paddingBottom = 0
        },

        enter(sg) {
          sg.dataset.oldOverflow = sg.style.overflow
          if (sg.scrollHeight !== 0) {
            sg.style.maxHeight = `${sg.scrollHeight}px`
            sg.style.paddingTop = sg.dataset.oldPaddingTop
            sg.style.paddingBottom = sg.dataset.oldPaddingBottom
          } else {
            sg.style.maxHeight = 0
            sg.style.paddingTop = sg.dataset.oldPaddingTop
            sg.style.paddingBottom = sg.dataset.oldPaddingBottom
          }

          sg.style.overflow = 'hidden'
        },

        afterEnter(sg) {
          sg.style.maxHeight = ''
          sg.style.overflow = sg.dataset.oldOverflow
        },

        beforeLeave(sg) {
          if (!sg.dataset) sg.dataset = {}
          sg.dataset.oldPaddingTop = sg.style.paddingTop
          sg.dataset.oldPaddingBottom = sg.style.paddingBottom
          sg.dataset.oldOverflow = sg.style.overflow

          sg.style.maxHeight = `${sg.scrollHeight}px`
          sg.style.overflow = 'hidden'
        },

        leave(sg) {
          if (sg.scrollHeight !== 0) {
            sg.style.maxHeight = 0
            sg.style.paddingTop = 0
            sg.style.paddingBottom = 0
          }
        },

        afterLeave(sg) {
          sg.style.maxHeight = ''
          sg.style.overflow = sg.dataset.oldOverflow
          sg.style.paddingTop = sg.dataset.oldPaddingTop
          sg.style.paddingBottom = sg.dataset.oldPaddingBottom
        },
      },
    }
  },
})
</script>
